import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <span className="text-foreground-500 text-xs font-medium tracking-wide uppercase">
            吃瓜频道
          </span>
          <h2 className="text-3xl md:text-5xl font-heading text-foreground-950 font-black leading-tight mt-2">
            按瓜分类
            <br />
            精准吃瓜
          </h2>
        </div>

        {/* Category grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-lg p-6 hover:bg-accent-500 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center mb-4">
                <i
                  className={`${cat.icon} text-2xl text-foreground-800 group-hover:text-background-50 transition-colors duration-300`}
                ></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 group-hover:text-background-50 transition-colors duration-300 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 group-hover:text-background-50/80 transition-colors duration-300 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}